<template>
  <el-card>
    <el-form class="global-form2" ref="form" :model="formData" :rules="rules" label-width="100px"
      label-position="right">
      <el-form-item label="物品名称" prop="itemName">
        <el-input v-model="formData.itemName" placeholder="请输入物品名称"></el-input>
      </el-form-item>
      <el-form-item label="所属公园" prop="projectId">
        <el-select v-model="formData.projectId" placeholder="请选择所属公园" filterable>
          <el-option v-for="(item, index) in parkList" :key="index" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="fileList">
        <template slot="label">
          <span>物品封面图<br>(1张)</span>
        </template>
        <custom-upload v-model="formData.fileList" :limit="1"></custom-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit" :disabled="disabled">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'LostfoundAdd',
  data() {
    return {
      disabled: false,
      parkList: [],
      itemsList: [],
      formData: {
        projectId: '',
        itemName: '',
        fileList: []
      },
      rules: {
        itemName: [
          { required: true, message: '请输入物品名称', trigger: ['blur', 'change'] }
        ],
        projectId: [
          { required: true, message: '请输入所属公园', trigger: ['blur', 'change'] }
        ],
        fileList: [
          { required: true, message: '请选择物品封面图', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  created() {
    this.getPark()
    if (this.id) {
      this.loadData()
    }
  },
  methods: {
    // 获取公园列表
    getPark() {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.parkList = res.list || []
      })
    },
    loadData() {
      this.$axios.get(this.$apis.tourist.selectLostAndFoundById, {
        id: this.id
      }).then(res => {
        this.formData = res || {}
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        this.disabled = true
        const url = this.id ? this.$apis.tourist.updateLostAndFound : this.$apis.tourist.insertLostAndFound
        this.$axios.post(url, this.formData).then(() => {
          this.$router.push('/Lostfound')
        }).finally(() => {
          this.disabled = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
